// 外包端（版权方视角）IP合作状态枚举（对外契约，与后端 IpCooperationCopyrightOwnerStateEnum 对齐）。
// 外包端不暴露内部二级单状态（IpCooperationL2StateEnum），统一用本枚举：
//  - OFFER_NEGOTIATING（Offer谈判）← 内部 OFFER_NEGOTIATION / OFFER_NEGOTIATION_REVIEW（提交前后同阶段）
//  - OFFER_PENDING_CONFIRM（Offer待确认）← 内部 OA_AWARD_APPROVAL（OA定标审批）
//  - OFFER_CONFIRMED（Offer已确认）← 内部 IN_PROGRESS（进行中）
export const IP_COPYRIGHT_OWNER_STATE = {
  OFFER_NEGOTIATING: 'OFFER_NEGOTIATING',
  OFFER_PENDING_CONFIRM: 'OFFER_PENDING_CONFIRM',
  OFFER_CONFIRMED: 'OFFER_CONFIRMED',
} as const;

export type IpCopyrightOwnerStateCode =
  (typeof IP_COPYRIGHT_OWNER_STATE)[keyof typeof IP_COPYRIGHT_OWNER_STATE];
